import {IAppointmentIndicator} from './appointment-indicator.interface';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {StorageService} from '../../services/storage/storage.service';

export interface IRAppointmentIndicator {
  indicator: IAppointmentIndicator;
  visibility: boolean;
  isAppointmentComplete: boolean;
}

export namespace AppointmentIndicatorActions {
  export class SetIndicator {
    static readonly type: string = '[APPOINTMENT INDICATOR] Set Appointment Indicator Action';
    constructor(public appointmentIndicator: IAppointmentIndicator) {}
  }

  export class SetIndicatorVisibility {
    static readonly type: string = '[APPOINTMENT INDICATOR] Set Appointment Indicator Visibility Action';
    constructor(public visibility: boolean, public appointmentId?: string, public isFinish?: boolean, public seconds?: number) {}
  }
}


@State<IRAppointmentIndicator>({
  name: 'appointmentIndicatorState',
  defaults: {
    visibility: false,
    indicator: null,
    isAppointmentComplete: false
  }
})

@Injectable()
export class AppointmentIndicatorState {
  constructor(
    private storageService: StorageService
  ) {
  }
  url = environment.SERVER_URL;

  @Selector()
  public static getIndicatorVisibility(state: IRAppointmentIndicator): boolean {
    return state.visibility;
  }

  @Selector()
  public static getIndicatorIsComplete(state: IRAppointmentIndicator): boolean {
    return state.isAppointmentComplete;
  }

  @Action(AppointmentIndicatorActions.SetIndicator)
  async setAppointmentIndicatorAction(ctx: StateContext<IRAppointmentIndicator>, action: AppointmentIndicatorActions.SetIndicator): Promise<void> {
    ctx.patchState({
      indicator: action.appointmentIndicator
    });
  }

  @Action(AppointmentIndicatorActions.SetIndicatorVisibility)
  async setAppointmentIndicatorVisibilityAction(ctx: StateContext<IRAppointmentIndicator>,
                                                action: AppointmentIndicatorActions.SetIndicatorVisibility): Promise<void> {
    const times: {date: Date, appointmentId: string}[] = this.storageService.getSessionItem<{date: Date, appointmentId: string}[]>('consultationStart') ?? [];
    if (action.visibility && action.appointmentId && !times.find(item => item.appointmentId === action.appointmentId)) {
      const date: Date  = new Date();
      times.push({
        date,
        appointmentId: action.appointmentId
      });
      this.storageService.setSessionItem('consultationStart', times);
    }
    if (!action.visibility) {
      ctx.patchState({
        isAppointmentComplete: true
      });
    }
    ctx.patchState({
      visibility: action.visibility,
      isAppointmentComplete: false
    });
  }
}
